module.exports = __webpack_public_path__ + "24c06c881e535fe3d6111b03035171fa.png";